var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9986 21H20.5896C20.8152 20.9994 20.998 20.8167 20.9985 20.591V3.40898C20.998 3.18333 20.8152 3.00052 20.5896 3H15.9986C15.1701 3 14.4986 2.32842 14.4986 1.5C14.4986 0.671578 15.1701 0 15.9986 0H20.5896C22.4714 0.00220313 23.9963 1.52719 23.9985 3.40898V20.591C23.9963 22.4728 22.4714 23.9978 20.5896 24H15.9986C15.1701 24 14.4986 23.3284 14.4986 22.5C14.4986 21.6716 15.1701 21 15.9986 21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31654 8.818L5.19854 4.939C5.78452 4.3533 6.73435 4.35353 7.32005 4.93952C7.90575 5.5255 7.90552 6.47533 7.31953 7.06103L3.90755 10.472L17.4985 10.5C18.327 10.5 18.9985 11.1716 18.9985 12C18.9985 12.8284 18.327 13.5 17.4985 13.5L3.85252 13.475L7.31953 16.942C7.884 17.5484 7.85002 18.4976 7.24369 19.062C6.66736 19.5985 5.77435 19.5981 5.19854 19.061L1.31953 15.182C-0.437857 13.4247 -0.437857 10.5754 1.31949 8.8181L1.31953 8.81805L1.31654 8.818Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.3e60f88e042b1e6c8260105b60a9389e.svg";
export { ForwardRef as ReactComponent };